<template>
  <div v-if="!isLoading" class="wrapper-content w-100" :class="{'hide-dz-success': isHideDzSuccess}" id="decretos-new-or-edit">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2 class="mb-0">Decretos - Carga Automática <template v-if="form.name">- '{{form.name}}'</template></h2>
      <a-button
        v-if="isOnEditMode"
        class="mt-3 no-hover"
        type="primary"
      >
        {{form.status.name}}
      </a-button>
    </div>
    <b-card no-body class="border">
      <b-tabs card v-if="form.documentContent.permiteGuardar">
        <b-tab :active="!form.readyToNotificate" title="Contenido">
          <div class="row">
            <LmTextInput
              autofocus
              class="col-12"
              v-model="form.name"
              label="Título"
              :disabled="immutable"
              :v="$v.form.name"
              />
          </div>
          <h4>Cuerpo Decreto</h4>
          <div class="row">
            <LmEditor
              :disabled="immutable"
              ref="lmEditorSeccionVisto"
              class="col-12"
              @onUpdate="form.documentContent.seccionVisto = $event"
              label="Visto"
              :v="$v.form.documentContent.seccionVisto"
              :contentProps="form.documentContent.seccionVisto"
              :activeTable="false"
            />
            <LmEditor
              :disabled="immutable"
              ref="lmEditorSeccionConsiderando"
              class="col-12"
              @onUpdate="form.documentContent.seccionConsiderando = $event"
              label="Considerando"
              :v="$v.form.documentContent.seccionConsiderando"
              :contentProps="form.documentContent.seccionConsiderando"
              :activeTable="false"
            />
          </div>
          <div class="row">
            <LmTextInput
              class="col-12"
              v-model="form.documentContent.seccionFinal"
              :maxLength=256
              :disabled="true"
              />
          </div>
          <hr>
          <h4>Decreta</h4>
          <div
            v-for="(articulo, index) in form.documentContent.articulos"
            :key="`decreta-${index}`"
            class="row">
            <LmEditor
              ref="lmEditor"
              :disabled="immutable"
              class="col-10 col-lg-10"
              v-model="form.documentContent.articulos[index].articuloContent"
              :label="`Art.${index + 1}º`"
              :v="$v.form.documentContent.articulos.$each.$iter[index].articuloContent"
              :contentProps="form.documentContent.articulos[index].articuloContent"
            />
            <button
              class="btn btn-link text-danger col-2 mt-5"
              @click="removeArt(index)"
              :disabled="form.documentContent.articulos.length <= 1 || immutable"
              >
              <font-awesome-icon icon="trash" />
              <span class="ml-1">Eliminar Artículo</span>
            </button>
          </div>
          <LmButton
            id="new-article"
            type="button"
            value="Nuevo Artículo"
            :disabled="immutable"
            @click.native="form.documentContent.articulos.push({ articuloContent: '' })"
            buttonClass="btn-primary btn-sm"
            lmButtonWrapperClass="col-auto"
            lmButtonRootWrapperClass="d-inline-block mr-1"
          />
          <hr>
          <div class="row">
            <div class="col-12 h4">Notificaciones</div>
            <LmTreeSelect
              class="col-12 col-md-6"
              label="Responsable de Notificaciónes"
              :disabled="immutable"
              :pathToGetOptions="`/profilegroups/users/${notificationProfileGroup}`"
              v-model="$v.form.notificationUsers.$model"
              :multiple="true"
              :v="v('form.notificationUsers')"
            />
            <!-- <LmTextInput
              label="Dirección de envío del correo"
              :disabled="immutable"
              class="col-12 col-md-6"
              v-model="form.emailFrom"
              /> -->
          </div>
        </b-tab>
        <b-tab title="Carga Automática">
          <div v-if="!immutable" class="row">
            <LmUploadFiles
              class="col-12"
              ref="lmCsvFiles"
              label="Subir CSV"
              @fileCreated="onAddCsvFile"
              :duplicateCheck="true"
              :hideRemoveAllToast="true"
              :dropzoneOptions="{
                acceptedFiles: acceptedFormats,
                previewsContainer: false,
                headers: {
                  'Cache-Control': null,
                  'X-Requested-With': null
                },
                withCredentials: true,
                thumbnailWidth: 150,
                maxFilesize: 100,
                timeout: 120000,
                addRemoveLinks: true,
                maxFiles: 1,
                clickable: true
              }"
            />
            <div class="col-12 mt-2 mb-4">
              <strong>Condiciones para el CSV:</strong>

              <ol>
                <li><strong>El archivo CSV debe tener como separador de columnas la coma (,) y no debe tener comillas.</strong></li>
                <li>Recordá subir un CSV que contenga una <strong>primera línea de encabezados.</strong></li>
                <li>Los encabezados puede ser cualquier palabra que describa las columnas que contiene el CSV.</li>
                <li>No te olvides de incluir la columna <strong>"email"</strong> en la columna que contiene los correos de los destinatarios.</li>
                <li>Y en cada fila del csv debés incluir <strong>la misma cantidad de columnas que corresponden a los encabezados</strong>, caso contrario la fila no podrá ser procesada.</li>
              </ol>
            </div>
            <div v-if="form.csvFile.length" class="col-12">
              <div v-for="(file, index) in form.csvFile" :key="index" class="d-flex justify-content-between align-items-center mb-2">
                <div class="d-flex align-items-center flex-grow-1">
                  <h5 class="mb-0 mr-3">{{ file.name }}</h5>
                </div>
                <div class="ml-auto">
                  <a :href="file.path" target="_blank" class="btn btn-sm btn-primary">
                    <a-icon type="download" />
                  </a>
                  <div v-if="!immutable" @click="onRemoveCsvFile(index)" class="btn btn-sm btn-danger ml-1">
                    <a-icon type="delete" />
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-12">
              <h4 class="text-center h3 mb-4 mt-4">
                No hay un CSV asociado.
              </h4>
            </div>
          </div>
          <hr v-if="form.calculatedProps.generationResult">
          <div v-if="form.calculatedProps.generationResult" class="row">
            <div class="col-12 h4">Resultado de la última generación de documentos</div>
            <div class="col-12">
              <div class="bg-dark text-light p-3 rounded font-monospace overflow-auto" style="max-height: 300px;">
                <pre class="mb-0"><code class="text-white" v-html="form.calculatedProps.generationResult"></code></pre>
              </div>
            </div>
          </div>
          <template v-if="form.pdfDocuments?.length">
            <div class="row">
              <h4 class="col-12">Documentos Generados Automáticamente</h4>
            </div>
            <div class="row">
              <div class="col-12">
                <b-list-group-item
                  v-for="(file, index) in form.pdfDocuments"
                  :key="index"
                  class="d-flex justify-content-between"
                  >
                  <font-awesome-icon class="bar mr-2" icon="bars" />
                  <button
                    type="button"
                    v-b-modal.anexosModal
                    class="btn btn-link p-0  text-truncate text-left w-100"
                    @click="setAnexosModalFile(file.generationResponse)"
                    >{{file.generationResponse.name}}</button>
                  <div class="d-flex justify-content-end align-items-center">
                    <b-badge variant="primary file-size">{{ formatBytes(file.generationResponse.size) }}</b-badge>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                <div class="d-flex justify-content-end">
                  <div class="text-left w-100">
                    <strong class="h5">
                      Tamaño total
                    </strong>
                  </div>
                  <b-badge variant="info file-size" class="mt-2">
                    {{ formatBytes(form.calculatedProps.totalSize) }}
                  </b-badge>
                </div>
                </b-list-group-item>
              </div>
            </div>
          </template>
          <hr v-if="form.calculatedProps.externalResult">
          <div v-if="form.calculatedProps.externalResult" class="row">
            <div class="col-12 h4">Resultado del envío al sistema externo</div>
            <div class="col-12">
              <div class="bg-dark text-light p-3 rounded font-monospace overflow-auto" style="max-height: 300px;">
                <pre class="mb-0"><code class="text-white" v-html="form.calculatedProps.externalResult"></code></pre>
              </div>
            </div>
            <div v-if="form.externalData?.url" class="col-12">
              <a
              :href="form.externalData.url"
              target="_blank"
              class="btn btn-primary mt-2"
              >
                Ir al documento en el sistema externo
              </a>
            </div>
            <div v-else class="col-12 mt-2">
              <LmButton
                v-if="form.isRunning"
                id="btn-submit-regenerate"
                type="submit"
                buttonClass="btn-success"
                :isProcessing="isProcessing"
                value="Sincronizar estado"
                lmButtonRootWrapperClass="d-inline-block mr-1"
                lmButtonWrapperClass="col"
                @click="onGetIdFromExternal"
              />
            </div>
          </div>
        </b-tab>
        <b-tab :active="form.readyToNotificate" title="Notificaciones">
          <template v-if="form.readyToNotificate">
            <b-table :items="form.notifications" :fields="notificationFields" striped hover>
              <template #cell(actions)="row">
                <b-button size="sm" @click="viewPDF(row.item)" variant="primary">
                  Ver PDF
                </b-button>
              </template>
            </b-table>

            <b-modal id="pdfModal" size="lg" title="Visualización del PDF" hide-footer>
              <iframe :src="currentPdfUrl" style="width: 100%; height: 70vh;" frameborder="0"></iframe>
            </b-modal>
            <LmButton
              v-if="!form.isFinished && actionsAvailables.canBeNotifiedByMe"
              id="btn-submit"
              type="submit"
              buttonClass="btn-primary"
              :isProcessing="isProcessing"
              :disabled="form.isSendingEmails"
              value="Enviar Correos"
              lmButtonRootWrapperClass="d-inline-block mr-1"
              lmButtonWrapperClass="col"
              @click.native="onSendEmailNotifications(false)"
            />
          </template>
          <template v-else>
            <div class="alert alert-info" role="alert">
              <div v-if="form.externalStatusData?.message">
                <div class="mb-4">Estado del documento en el sistema externo</div>
                <div class="bg-dark text-light p-3 rounded font-monospace overflow-auto" style="max-height: 300px;">
                  <pre class="mb-0"><code class="text-white" v-html="form.externalStatusData.message"></code></pre>
                </div>
              </div>
              <div v-else-if="!form.immutable">
                <i class="fas fa-info-circle"></i>
                El documento aún no fue enviado al sistema externo.
              </div>
              <div v-else>
                <i class="fas fa-info-circle"></i>
                El documento aún no ha finalizado su procesamiento en el sistema externo.
              </div>
            </div>
            <LmButton
              v-if="form.immutable"
              id="btn-check-status"
              :disabled="form.isUpdatingStatus"
              type="button"
              buttonClass="btn-primary"
              :isProcessing="isProcessing"
              value="Verificar estado del documento"
              lmButtonRootWrapperClass="d-inline-block mt-2"
              lmButtonWrapperClass="col"
              @click.native="checkDocumentStatus"
            />
          </template>
        </b-tab>
      </b-tabs>
    </b-card>
    <LmButton
      id="btn-cancel"
      type="button"
      buttonClass="btn-secondary"
      :isProcessing="isProcessing"
      :value="$t('Cancel')"
      @click.native="onGoBack"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
    />
    <LmButton
      v-if="!form.readyToNotificate"
      id="btn-submit"
      type="submit"
      :disabled="immutable"
      buttonClass="btn-primary"
      :isProcessing="isProcessing"
      :value="$t('Save')"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      @click.native="onSubmit(false)"
    />
    <LmButton
      v-if="isOnEditMode && !form.readyToNotificate"
      :disabled="form.isRunning || form.csvFile?.length === 0 || immutable"
      id="btn-submit-regenerate"
      type="submit"
      buttonClass="btn-warning"
      :isProcessing="isProcessing"
      value="Procesar y Generar Documentos"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      @click="onRegenerateConfirmation"
    />
    <LmButton
      v-if="isOnEditMode && !form.readyToNotificate"
      :disabled="form.isRunning || form.csvFile?.length === 0 || !form.readyToSend"
      id="btn-submit-regenerate"
      type="submit"
      buttonClass="btn-success"
      :isProcessing="isProcessing"
      value="Crear Decreto"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      @click="onSendToExternalConfirmation"
    />
    <b-modal id="anexosModal" :title="anexosModalFile.name" size="xl" hide-footer >
      <iframe :src="anexosModalFile.src" frameborder="0" style="height:75vh;" width="100%"></iframe>
    </b-modal>
  </div>
  <div v-else>
    <b-col><b-skeleton class="m-4" type="input"></b-skeleton></b-col>
    <b-col><b-skeleton class="m-4" type="input"></b-skeleton></b-col>
    <b-col md="12" class="m-4">
      <div>
        <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
          <span
            class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
            style="gap: 1rem"
            v-for="(item, index) in 4"
            :key="index"
          >
            <b-skeleton type="avatar"></b-skeleton>
            <b-skeleton width="200px"></b-skeleton>
          </span>
        </div>
        <div class="d-flex flex-wrap">
          <b-skeleton type="button" width="150px"></b-skeleton>
          <b-skeleton type="button" class="ml-4" width="150px"></b-skeleton>
        </div>
      </div>
    </b-col>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import lmFormatBytes from '@/mixins/lmFormatBytes.js'
import LmButton from '@/components/form/elements/LmButton'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmEditor from '@/components/form/elements/lmEditor'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import draggable from 'vuedraggable'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect.vue'

// Mixins
import lmStandardFormHelperMixin from '@/mixins/lmStandardFormHelperMixin'

// Utils
import commonsApi from '@/api/commons'

import store from '@/store'
import { mapActions } from 'vuex'
import { required, requiredIf, maxLength, minLength } from 'vuelidate/lib/validators'

import { notification } from 'ant-design-vue'

export default {
  mixins: [lmSuperPowerSelectHelper, lmStandardFormHelperMixin, lmFormatBytes],
  components: {
    LmForm,
    LmTextArea,
    LmTextInput,
    LmSuperPowerSelect,
    LmButton,
    lmConfirmationModal,
    LmEditor,
    LmNumberInput,
    LmUploadFiles,
    draggable,
    LmTreeSelect
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      dropzoneErrors: [],
      tomeConocimiento: [],
      refrenda: [],
      refrendaPendientes: [],
      placeholders: {
        refrendaPendientes: 'Secretaría',
        refrenda: 'Secretaría',
        tomeConocimiento: 'Secretaría'
      },
      filePreview: null,
      timeout: null,
      anexosModalFile: {
        src: '',
        name: ''
      },
      isHideDzSuccess: false,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        addRemoveLinks: true,
        acceptedFiles: 'application/pdf'
      },
      lmUploadFiles: [],
      acceptedFormats: [{ name: 'csv' }],
      notificationFields: [
        { key: 'email', label: 'Email' },
        { key: 'data', label: 'Datos' },
        { key: 'page', label: 'Página' },
        { key: 'actions', label: 'Acciones' }
      ],
      form: {
        name: '',
        documentContent: {
          origenes: [],
          articulos: [{ articuloContent: '' }],
          numeroExpedienteAsociado: '',
          seccionVisto: '',
          seccionConsiderando: '',
          seccionFinal: 'Es por ello que LA INTENDENTA MUNICIPAL DE VICENTE LOPEZ, en uso de las atribuciones que le son propias',
          refrenda: [],
          refrendaPendientes: [],
          tomeConocimiento: [],
          permiteGuardar: !this.isOnEditMode,
          permiteVisar: false,
          permiteFirmar: false,
          permiteVerHistorial: false,
          permitePrevisualizar: false,
          permiteCompartir: false,
          compartir: false,
          permiteEditarWorkflow: false,
          anexos: []
        },
        isRunning: false,
        readyToSend: false,
        readyToNotificate: false,
        immutable: false,
        isUpdatingStatus: false,
        isSendingEmails: false,
        isFinished: false,
        notificationUsers: [],
        emailFrom: '',
        csvFile: [],
        pdfDocuments: [],
        calculatedProps: {
          totalSize: 0,
          generationResult: '',
          externalResult: ''
        },
        externalData: {
          url: ''
        },
        externalStatusData: {
          message: ''
        },
        notifications: []
      },
      initialForm: {},
      currentPdfUrl: '',
      requireAllFields: false
    }
  },
  computed: {
    immutable () {
      return this.form.immutable
    },
    documentId () {
      return this.$route.params?.id || null
    },
    name: {
      get () {
        return this.isOnEditMode ? 'Editar' : 'Nuevo Decreto'
      },
      set () {}
    }
  },
  validations () {
    return {
      form: {
        name: {
          required
        },
        documentContent: {
          seccionVisto: {
            required: requiredIf(function () {
              return this.requireAllFields
            })
          },
          seccionConsiderando: {
            required: requiredIf(function () {
              return this.requireAllFields
            })
          },
          articulos: {
            minLength: minLength(1),
            $each: {
              articuloContent: {
                required: requiredIf(function () {
                  return this.requireAllFields
                })
              }
            }
          },
          anexos: {
            maxLength: maxLength(this.anexosLimit)
          }
        },
        notificationUsers: {
          required,
          notEmpty: value => value.length > 0
        }
      }
    }
  },
  props: {
    title: {
      type: String
    },
    notificationProfileGroup: {
      type: String,
      required: true
    },
    newOrEditEndpointUri: {
      type: String
    },
    isOnEditMode: {
      type: Boolean,
      required: true,
      default: false
    },
    anexosLimit: {
      type: Number,
      required: false,
      default: 40
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    async getActionsAvailables () {
      let targetEndpoint = `/${this.serviceEndpoint}/actionsavailable/`
      if (this.isOnEditMode) {
        targetEndpoint = `/${this.serviceEndpoint}/actionsavailable/${this.$route.params.id}`
      }
      const response = await commonsApi.axiosGetWrapper(targetEndpoint)
      this.actionsAvailables = response.data
    },
    viewPDF (item) {
      this.currentPdfUrl = item.url
      this.$bvModal.show('pdfModal')
    },
    onAddCsvFile (event) {
      this.hasChanged = true
      this.form.csvFile = []
      this.form.csvFile = [{
        id: event.id || event.uuid,
        ...event,
        src: event.path,
        path: process.env.VUE_APP_API_URL_STATIC_ASSETS + event.path
      }]
      this.$refs.lmCsvFiles.lmRemoveAllFiles()
      this.$refs.fileviewer.lazyLoadUpdate(this.form.csvFile[0])
    },

    onRemoveCsvFile () {
      this.form.csvFile = []
    },
    removeArt (index) {
      this.form.documentContent.articulos.splice(index, 1)
    },
    setAnexosModalFile (file) {
      this.anexosModalFile.src = file.src
      this.anexosModalFile.name = file.name
    },
    deleteUploadFile (index) {
      this.form.documentContent.anexos.splice(index, 1)
      this.lmUploadFiles.splice(index, 1)
    },
    fileCreated (file, response) {
      if (response) {
        this.isHideDzSuccess = false
        this.form.documentContent.anexos.push(response)
        setTimeout(() => {
          this.isHideDzSuccess = true
        }, 1000)
      }
    },
    fileRemoved (file, error, xhr) {
      this.form.documentContent.urlimagen = ''
      if (file) {
        this.form.documentContent.anexos = this.form.documentContent.anexos.filter(f => f.name !== file.name)
        this.$forceUpdate()
      }
    },
    dropzoneErrorHandler (file) {
      const error = {
        variant: '',
        message: ''
      }
      if (file?.xhr?.status === 413) {
        const maxValueAllowedByServe = JSON.parse(file?.xhr?.response).message.match(/\d+/g)[0]
        error.message = `Lo sentimos, el tamaño del archivo "${file.name}" excede el tamaño máximo permitido ${this.formatBytes(maxValueAllowedByServe)}`
        error.variant = 'danger'
      } else if (file.type !== 'application/pdf') {
        error.message = 'Lo sentimos, sólo puede subir archivos en formato PDF'
        error.variant = 'warning'
      } else {
        error.message = file?.xhr?.response ? JSON.parse(file?.xhr?.response).message : ''
        error.variant = 'danger'
      }
      this.$refs.lmUploadFiles.lmRemoveFile(file)
      this.dropzoneErrors.push(error)
    },
    async onSendToExternalConfirmation () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.sendToExternal()
            }
          }
        ],
        message: '<h4>Este acción va a iniciar la creación <br>del decreto en el Sistema Mesa3</h4><br>Una vez creado ya no podrás seguir editandolo desde la carga automática.<br><br>'
      })
    },
    async onRegenerateConfirmation () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.regenerate()
            }
          }
        ],
        message: '<h4>Este acción va a regenerar todos<br>los documentos a partir del CSV</h4><br>Si ya los habías procesado previamente, se van a borrar y reprocesar<br>Te informaremos una vez que la acción se haya completado.<br><br>'
      })
    },
    async onSendEmailNotifications () {
      this.lmModalInformationMessage({
        modalClosable: false,
        modalKeyboard: false,
        resultSubtitle: '',
        buttons: [
          {
            btnText: this.$t('cancel'),
            btnType: 'danger',
            btnGhost: true,
            btnCallback: () => {
              this.isProcessing = false
            }
          },
          {
            btnText: this.$t('continue'),
            btnCallback: () => {
              this.sendEmailNotifications()
            }
          }
        ],
        message: '<h4>Este acción va a enviar un mail a cada una<br>de las personas del CSV</h4><br>Una vez iniciado el proceso no puede cancelarse<br>y te informaremos una vez que la acción se haya completado.<br><br>'
      })
    },
    async sendToExternal () {
      try {
        await this.onSubmit(false)
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/send_to_external/${this.$route.params.id}`)
        this.form.isRunning = true
        this.form.readyToSend = false
        this.form.immutable = true
        this.lmToastSuccessMessage(
          'El documento fue enviado al sistema externo.  Recibirás una notificación cuando finalice el proceso.',
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        this.lmToastDangerMessage(
          'El documento no pudo ser enviado al sistema externo.',
          `${this.$t('something_went_wrong')}`
        )
      } finally {
        await this.loadData()
        this.isProcessing = false
        this.$nextTick(() => {
          this.hasChanged = false
        })
      }
    },
    async regenerate () {
      this.isProcessing = true
      try {
        await this.onSubmit(false)
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/regenerate/${this.$route.params.id}`)
        this.form.isRunning = true
        this.lmToastSuccessMessage(
          'Los documentos se están regenerando, recibirás una notificación cuando finalice ',
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
        this.$nextTick(() => {
          this.hasChanged = false
        })
      }
    },
    async sendEmailNotifications () {
      this.isProcessing = true
      try {
        this.form.isSendingEmails = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/send_email_notifications/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          'Los correos se están enviando, recibirás una notificación cuando finalice ',
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
        await this.loadData()
        this.$nextTick(() => {
          this.hasChanged = false
        })
      }
    },
    async checkDocumentStatus () {
      this.isProcessing = true
      try {
        this.form.isUpdatingStatus = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/update_status_from_external/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          'Estamos validando el estado del documento en el sistema externo.  Recibirás una notificación cuando finalice el proceso.',
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        await this.loadData()
        this.isProcessing = false
        this.$nextTick(() => {
          this.hasChanged = false
        })
      }
    },
    async onGetIdFromExternal () {
      this.isProcessing = true
      try {
        this.form.isUpdatingStatus = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/get_id_from_external/${this.$route.params.id}`)
      } catch (error) {
        console.log(error)
      } finally {
        await this.loadData()
        this.isProcessing = false
        this.$nextTick(() => {
          this.hasChanged = false
        })
      }
    },
    async refresh () {
      this.isProcessing = true
      await this.loadData()
      this.isProcessing = false
    }
  },
  async mounted () {
    if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
      const key = `open${Date.now()}`
      this.sockets.subscribe(`onDocument_${this.documentId}`, async _ => {
        notification.success({
          message: 'Documento actualizado',
          description:
          'Por favor, recarga para ver las novedades.',
          duration: 0,
          btn: h => {
            return h(
              'a-button',
              {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.refresh()
                    notification.close(key)
                  }
                }
              },
              this.$t('refresh')
            )
          },
          key,
          onClose: close
        })
      })
    }
  },

  beforeRouteLeave (to, from, next) {
    if (process.env.VUE_APP_SOCKET_ENABLED === 'yes') {
      this.sockets.unsubscribe(`onDocument_${this.documentId}`)
    }
    next()
  }
}
</script>

<style lang="sass">
.modal-huge
  max-width: 75%
  width: 75%
</style>

<style lang="sass" scoped>
#decretos-new-or-edit
  .lm-collapse
    top: 35px
    right: 0
    z-index: 1
  .estado-decreto
    h2
      margin-bottom: 40px
    margin-top: 20px
    margin-bottom: 40px
  .collapsing
    transition: none
  .close
    cursor: pointer
    font-size: 20px
  .bar
    cursor: grab
    font-size: 20px
  .f-icon
    top: 3px
    position: relative
  .file-name
    width: 50%
    @media(min-width: $lg)
      width: 70%
  .file-size
    line-height: 1.5
  #pdfViewer
    min-height: 500px
  .refrendadas-pendientes
    margin-top: 20px

  .no-hover
    cursor: default !important

  .no-hover:hover
    cursor: default !important
</style>
